__turbopack_context__.v({
  "calendarIcon": "EventDetails-module-scss-module__BrKLVG__calendarIcon",
  "locationIcon": "EventDetails-module-scss-module__BrKLVG__locationIcon",
  "organizerInfoWrapper": "EventDetails-module-scss-module__BrKLVG__organizerInfoWrapper",
  "presenterInfoWrapper": "EventDetails-module-scss-module__BrKLVG__presenterInfoWrapper",
  "secondaryText": "EventDetails-module-scss-module__BrKLVG__secondaryText",
  "venueAndDateTimeWrapper": "EventDetails-module-scss-module__BrKLVG__venueAndDateTimeWrapper",
  "wrapper": "EventDetails-module-scss-module__BrKLVG__wrapper",
});
